import React from "react";
import { AspectRatio, Box } from "@chakra-ui/react";
import Image from "next/image";
import { ChakraBox } from "ui/chakra-framer";
import customerStudioScreenshot from "../../../../../public/assets/solutions/advertising/customer-studio-screenshot.png";

export function CustomerStudioPreview() {
  const dropShadowFilter = "drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.08))";
  const aspectRatioImage = (
    <AspectRatio ratio={592 / 507} filter={dropShadowFilter} overflow="hidden">
      <Image src={customerStudioScreenshot} alt="Preview of using Customer Studio to define an audience." />
    </AspectRatio>
  );

  return (
    <>
      <Box w="100%" pl={{ base: 6 }} display={{ base: "block", md: "none" }} filter={dropShadowFilter}>
        {aspectRatioImage}
      </Box>

      <ChakraBox
        initial={{ x: "20%" }}
        whileInView={{ x: "0", transition: { ease: "easeInOut", duration: 0.7 } }}
        viewport={{ once: true, amount: 0.6 }}
        display={{ base: "none", md: "block" }}
      >
        {aspectRatioImage}
      </ChakraBox>
    </>
  );
}
